import { InjectionToken } from '@angular/core';

import { Request, Response } from 'express';
import { Observable } from 'rxjs';

import { RawEnv } from '../environment/environment.types';

interface ResponseLocals extends Record<string, unknown> {
  rawEnv?: RawEnv;
  skipDataCache?: boolean;
}

export type ServerResponse = Response<string, ResponseLocals>;
export interface ServerRequest extends Request {
  res: ServerResponse;
}

/**
 * The below tokens are to be used for decoupling util-core from universal dependencies.
 * In app.server.config configure them as providers:
 *
 * import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
 * ...
 *   providers: [
 *     { provide: SERVER_REQUEST, useExisting: REQUEST },
 *     { provide: SERVER_RESPONSE, useExisting: RESPONSE }
 *   ]
 */

export const SERVER_REQUEST = new InjectionToken<ServerRequest>('util-core.serverRequest');
export const SERVER_RESPONSE = new InjectionToken<ServerResponse>('util-core.serverResponse');

export type CacheManagerWrapObservable<T = string> = (
  cacheKey: string,
  process$: Observable<T>,
  ttl?: number
) => Observable<T>;

/**
 * The injection token will be provided only on server-side when using NgExpressCacheEngine.
 * It exposes CacheManagerService.wrap$() method returning an Observable for retrieving/pushing
 * data from/to the server-side cache.
 */
export const CACHE_MANAGER_WRAP = new InjectionToken<CacheManagerWrapObservable>(
  'util-core.cacheManagerWrapObservable'
);
